import { useCallback } from 'react';
import isEmail from 'validator/lib/isEmail';
import isMobilePhone from 'validator/lib/isMobilePhone';

import { useConfig } from '../../../defaultConfig';
import useTranslation from '../../../hooks/useTranslation';
import TranslationsConfigType from '../../../translations/translationType';
import { UseValidateHook } from '../../../utils/validation/validateTypes';
import { UpdateContactInfoState } from './state';

export type Error = {
    email?: string;
    mobile?: string;
};

export const isValidEmail = (value?: string, enabled = true) => {
    if (!enabled) return true;
    if (!value || value.length === 0) {
        return false;
    }

    return isEmail(value);
};

export const isValidPhoneNumber = (value?: string, enabled = true) => {
    if (!enabled) return true;
    if (!value || value.length === 0) {
        return false;
    }

    return isMobilePhone(value);
};

const validate =
    (enablePhoneNumberValidation = false, enableEmailValidation = false) =>
    (translated: TranslationsConfigType) =>
    (formState: UpdateContactInfoState): Error => {
        const errors: Error = {
            email: undefined,
            mobile: undefined,
        };

        const { email, mobile } = formState;

        if (email && !isValidEmail(email, enableEmailValidation)) {
            errors.email = translated.contactInfo.errors.wrongEmailFormat;
        }

        if (!isValidPhoneNumber(mobile, enablePhoneNumberValidation)) {
            errors.mobile = translated.contactInfo.errors.wrongMobileFormat;
        }

        return errors;
    };

export const useValidate: UseValidateHook<UpdateContactInfoState, Error> = () => {
    const { featureToggles } = useConfig();
    const translated = useTranslation();

    return useCallback(
        async (state) => {
            return validate(featureToggles.enableUpdatingMobilenumber, featureToggles.enableUpdatingEmail)(translated)(
                state,
            );
        },
        [translated, featureToggles.enableUpdatingMobilenumber, featureToggles.enableUpdatingEmail],
    );
};
